import script from "./BeyondComparePage.vue?vue&type=script&setup=true&lang=js"
export * from "./BeyondComparePage.vue?vue&type=script&setup=true&lang=js"

import "./BeyondComparePage.vue?vue&type=style&index=0&id=e31c8966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e31c8966"]])

export default __exports__